import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./AdvertenciaHeader.scss"

const AdvertenciaHeader = ({ children, className }: $TSMigrationFixMe) => {
  return (
    <div
      className={`advertencia-header p-inline-message-info ${className || ""}`}
    >
      <FontAwesomeIcon
        // @ts-expect-error TS(2322): Type '"fa-circle-info"' is not assignable to type ...
        icon={["fal", "fa-circle-info"]}
        className='mr-2'
      />

      {children}
    </div>
  )
}

export default AdvertenciaHeader
